import { render } from "./BaseDialog.vue?vue&type=template&id=61b4ecfc&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=61b4ecfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61b4ecfc"

export default script